import * as yup from 'yup';

export const translationBasePath = '_LOGIN._MFA';

export const validationSchema = (t) =>
  yup.object({
    code: yup.string().required(t(`${translationBasePath}._CODE_REQUIRED`)),
  });
